module.exports = __webpack_public_path__ + "static/images/components/InfoButton/images/info.ffe123e1.png";


//////////////////
// WEBPACK FOOTER
// ./components/InfoButton/images/info.png
// module id = 2604
// module chunks = 11